import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the bundle and promotion api
 */
export class GPSEventService extends BaseService {

	constructor() {	
		super();
	}
	
	async getEventsForCustomer(paging, customerId) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/secure-fuel-events/search/' + customerId + params);		
		return data;		
	}
		
	async getLatestEventForCustomer(customerId, unitId) {	
		var params = '';
		if (unitId) {
			params = '?unitId=' + encodeURIComponent(unitId);
		}
		var data = await this.makeGETRequest('/api/resource/secure-fuel-events/latest/' + customerId + params);		
		return data;		
	}

	exportEventsForCustomer(paging, customerId) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/secure-fuel-events/search/' + customerId + '/export' + params);
	}
	
}